var sentenceCase = require('sentence-case')

/**
 * Param case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return sentenceCase(string, locale, '-')
}



//////////////////
// WEBPACK FOOTER
// ./~/param-case/param-case.js
// module id = 1168
// module chunks = 4